import { APP_NAME } from 'app-config'

import { IRequestOptions, IResponseResult } from 'models/api.model'
import { IRawVariant } from 'models/variant.model'

import { ApiService } from 'services/api.service'

import { RequestMethod } from 'root-constants'
import { TAppName } from 'root-types'

export class VariantsApi {
  private api: ApiService
  private readonly appName: TAppName = APP_NAME

  constructor(api: ApiService) {
    this.api = api
  }

  getVariant({
    cohort,
  }: {
    cohort: string
  }): Promise<IResponseResult<IRawVariant>> {
    const options: IRequestOptions = {
      method: RequestMethod.GET,
      params: { cohort },
    }

    return this.api.makeRequest<IRawVariant>(
      `v1/flow/${this.appName}/variants`,
      options,
    )
  }
}
